"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleButtonGroupNovoDark = exports.toggleButtonGroupNovo = exports.toggleButtonGroup = exports.toggleButtonNovoDark = exports.toggleButtonNovo = exports.toggleButton = void 0;
const polished_1 = require("polished");
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const size_const_1 = __importDefault(require("../choices/size.const"));
const color_const_1 = __importDefault(require("../choices/color.const"));
const { novo, novoDark } = oxygen_theme_1.default;
const toggleButton = {
    backgroundColor: color_const_1.default.cloudyBlue,
    backgroundColorSelected: color_const_1.default.dodgerBlue,
    // @deprecated - use `outlineColorFocus`
    backgroundColorFocus: color_const_1.default.dodgerBlue300,
    outlineColorFocus: color_const_1.default.dodgerBlue300,
    knobColor: color_const_1.default.white,
    knobColorDisabled: color_const_1.default.white,
    knobMargin: size_const_1.default.small,
    height: '20px',
    width: '32px',
    margin: size_const_1.default.default,
    knobSize: '14px',
    labelDisabledColor: (0, polished_1.rgba)(color_const_1.default.pickledBluewood800, 0.5),
    iconSet: 'classic',
};
exports.toggleButton = toggleButton;
const toggleButtonGroup = {
    verticalGroupMargin: size_const_1.default.default,
    horizontalGroupMargin: size_const_1.default.default2x,
};
exports.toggleButtonGroup = toggleButtonGroup;
const toggleButtonNovo = {
    ...toggleButton,
    backgroundColor: novo.ui03,
    backgroundColorDisabled: novo.ui03,
    // @deprecated - use `outlineColorFocus`
    backgroundColorFocus: novo.focus01,
    outlineColorFocus: novo.focus01,
    backgroundColorSelected: novo.action04,
    knobColor: novo.icon02,
    knobColorDisabled: novo.icon03,
    knobMargin: '4px',
    height: '24px',
    width: '40px',
    margin: '16px',
    knobSize: '16px',
    labelDisabledColor: novo.disabled02,
    iconSet: 'novo',
};
exports.toggleButtonNovo = toggleButtonNovo;
const toggleButtonNovoDark = {
    ...toggleButtonNovo,
    backgroundColor: novoDark.ui03,
    backgroundColorDisabled: novoDark.ui03,
    backgroundColorSelected: novoDark.action04,
    outlineColorFocus: novoDark.focus01,
    knobColorDisabled: novoDark.icon03,
    labelDisabledColor: novoDark.disabled02,
};
exports.toggleButtonNovoDark = toggleButtonNovoDark;
const toggleButtonGroupNovo = {
    verticalGroupMargin: novo.spacing03,
    horizontalGroupMargin: novo.spacing06,
};
exports.toggleButtonGroupNovo = toggleButtonGroupNovo;
const toggleButtonGroupNovoDark = {
    ...toggleButtonGroupNovo,
};
exports.toggleButtonGroupNovoDark = toggleButtonGroupNovoDark;
